module.exports = __webpack_public_path__ + "static/media/menu_empty_screen.1c7ac613.png";